module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider1Post-8ff10fd0.jpeg";